import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useMyGlobal } from "../../component/GlobalData";
import { slugify } from '../../component/utility';
import { useNavigate } from 'react-router-dom';

const CategoryPage = () => {

    const { windowWidth } = useMyGlobal();
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();

    const idCategory = searchParams.get("id");
    const name = searchParams.get("name")

    const { categoryDataNav } = useMyGlobal();
    const { categoryData } = useMyGlobal();

    const [isPortrait, setIsPortrait] = useState(false);
    /*
    const category = categoryDataNav?.find(
        item => String(item.id_category) === String(idCategory)
    );
    */
    const category =
        categoryDataNav?.find(
            item => String(item.id_category) === String(idCategory)
        ) ||
        categoryData?.find(
            item => String(item.id_category) === String(idCategory)
    );

    const children = category?.child || [];

    console.log("allCategory:", categoryData);
    console.log("idCategory:", idCategory);
    console.log("category:", category);
    console.log("children:", children);
    console.log("name:", name);

    
    const [paddingTop, setPaddingTop] = useState(0);

    useEffect(() => {
        const updatePadding = () => {
            const topbar =
                document.querySelector(".topbar");

            const navbar =
                document.querySelector(".is-navbar");

            const topbarHeight = topbar?.offsetHeight || 0;
            const navbarHeight = navbar?.offsetHeight || 0;

            setPaddingTop(topbarHeight + navbarHeight);

            //console.log('cek topbar : ' , topbarHeight)
            //console.log('cek navbar : ' , navbarHeight)
        };

        updatePadding();

        window.addEventListener("resize", updatePadding);

        return () => window.removeEventListener("resize", updatePadding);
    }, []);

      const handleClickChild = (parent, childId) => {
        console.log(parent)
        let data = parent
        const category_name = parent.hasOwnProperty('child') ? parent.child.find(i => i.id_category_child == childId).category_name : parent.category_name
        const slug_string = parent.hasOwnProperty('child') ? parent.child.find(i => i.id_category_child == childId)?.slug : null
        data.from = 'child'
        data.selected_child = childId
        const slug = slug_string ? slug_string : data.slug ? data.slug : slugify(category_name)
        navigate(`/product_list/${childId}/${slug}`, { state: data })
      }

    return (
        
        <section
            style={{
                minHeight: "90vh",
                height: "100%",
                paddingTop: `${paddingTop}px`
            }}
        >
            <div className="banner-inner">
                <img
                    className="img-fluid d-block w-100"
                    src={category?.header_image}
                    alt={category?.category_name}
                />
            </div>

            <Container
                className="pb-5"
            >

                <Row className="g-3 mt-3">
                    {children.map((item) => (
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} key={item.id_category_child}>
                            <div
                                className="category-card zoom-2"
                                style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    overflow: "hidden",
                                    ...(isPortrait && {
                                        aspectRatio: "1 / 1"
                                    })
                                }}
                                onClick={() =>
                                    handleClickChild(category, item.id_category_child)
                                }
                            >
                                <img
                                    src={item.thumbnail_image}
                                    alt={item.category_name}
                                    onLoad={(e) => {
                                        setIsPortrait(
                                            e.currentTarget.naturalHeight >
                                            e.currentTarget.naturalWidth
                                        );
                                    }}
                                    style={{
                                        width: "26rem",
                                        height: isPortrait ? "26rem" : "auto",
                                        display: "block",
                                        objectFit: isPortrait ? "cover" : "contain"
                                    }}
                                />

                                {/* Overlay */}
                                <div
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        background: "rgba(0, 0, 0, 0.55)"
                                    }}
                                />

                                {/* Category Name */}
                                <div
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                >
                                    <h3
                                        style={{
                                            margin: 0,
                                            color: "#fff",
                                            fontWeight: 600,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        {item.category_name}
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>

                
                <Row className="mb-3" style={{marginTop: "6rem"}}>
                    { category ?
                        <Col xl={12} lg={12} md={12} className="text-center">
                            <h1 className="text-uppercase" style={{ fontSize: '3.5em' }}>
                                {
                                    {
                                        MEN: "MEN'S CATEGORY",
                                        WOMEN: "WOMEN'S CATEGORY",
                                        KIDS: "KIDS CATEGORY",
                                        ACCESSORIES: "ACCESSORIES CATEGORY"
                                    }[category?.category_name?.toUpperCase()]
                                    || `CATEGORY ${category?.category_name?.toUpperCase()}`
                                }
                            </h1>
                            <h3 className="fs-5 fw-light" style = {{textAlign: 'justify'}}>
                                {
                                    category?.description
                                }
                            </h3>
                        </Col>
                        :
                        <></>
                    }
                </Row>

            </Container>
        </section>
    );
};

export default CategoryPage;